import Case from '../../../models/case';

export default function redirectToCase(id, clinicId) {
  return Case.getCaseByCaseName(id)
    .then(res => res.patientData.id)
    .then(patientId => window.open(`/${clinicId}/case/${patientId}/${id}`))
    .catch(err => console.log(err));
}
